// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Restaumatic_Cart_ProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic_Cart_PromotionData from "../Restaumatic.Cart.PromotionData/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic_Menu_Promotions from "../Restaumatic.Menu.Promotions/index.js";
import * as Restaumatic_Promotions_Types from "../Restaumatic.Promotions.Types/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
var PromotionalItem = function (x) {
    return x;
};
var showPromotionalItem = {
    show: function (v) {
        return Data_String_Common.joinWith("\x0a")([ "PromotionalItem", " { engineItem = " + Data_Show.show(Restaumatic_PromotionsEngine_Cart_PromotionalItem.showPromotionalItem(Restaumatic_Cart_ProductKey.showProductKey))(v.engineItem), " , promotion = " + Data_Show.show(Restaumatic_Promotions_Types.showPromotion)(v.promotion), " }" ]);
    }
};
var promotionalItemPrice = function (v) {
    if (Restaumatic_PromotionsEngine_Cart_PromotionalItem.isEnabled(v.engineItem)) {
        return Data_Maybe.fromMaybe(Data_Numeric.zero(Data_Money_Rounded.additiveMoney))(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionalItemValue(v.engineItem));
    };
    if (Data_Boolean.otherwise) {
        return Data_Numeric.zero(Data_Money_Rounded.additiveMoney);
    };
    throw new Error("Failed pattern match at Restaumatic.Cart.PromotionalItem (line 65, column 1 - line 65, column 49): " + [ v.constructor.name ]);
};
var promotionalItemMarketingConsent = function (v) {
    return (function (v1) {
        return v1.requiresMarketing;
    })(Data_Newtype.unwrap()(v.promotion));
};
var promotionalItemId = function (v) {
    return Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionalItemId(v.engineItem);
};
var newtypePromotionalItem = {
    Coercible0: function () {
        return undefined;
    }
};
var promotionalItemDetails = /* #__PURE__ */ (function () {
    var $25 = Data_Newtype.unwrap();
    return function ($26) {
        return (function (v) {
            return v.details;
        })($25($26));
    };
})();
var promotionalItemEngineItem = /* #__PURE__ */ (function () {
    var $27 = Data_Newtype.unwrap();
    return function ($28) {
        return (function (v) {
            return v.engineItem;
        })($27($28));
    };
})();
var promotionalItemAssignment = function ($29) {
    return Restaumatic_PromotionsEngine_Cart_PromotionalItem.assignment(promotionalItemEngineItem($29));
};
var promotionalItemInput = /* #__PURE__ */ (function () {
    var $30 = Data_Newtype.unwrap();
    return function ($31) {
        return (function (v) {
            return v.input;
        })($30(promotionalItemEngineItem($31)));
    };
})();
var promotionalItemIsActive = function ($32) {
    return Restaumatic_PromotionsEngine_Cart_PromotionalItem.isActive(promotionalItemEngineItem($32));
};
var promotionalItemPromotionId = function ($33) {
    return Restaumatic_Promotions_Types_Id.PromotionId(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionId(promotionalItemEngineItem($33)));
};
var promotionalItemSelectable = function ($34) {
    return Restaumatic_PromotionsEngine_Cart_PromotionalItem.hasRequiredInput(promotionalItemEngineItem($34));
};
var promotionalItemSelected = function ($35) {
    return Restaumatic_PromotionsEngine_Cart_PromotionalItem.isEnabled(promotionalItemEngineItem($35));
};
var promotionalItemsPartitionCombineable = function (promotionalItems) {
    var v = Restaumatic_PromotionsEngine_Cart_PromotionalItem.partitionCombineable(Data_Functor.map(Data_Functor.functorArray)(promotionalItemEngineItem)(promotionalItems));
    var nonCombineable = Data_Array.filter(function (item) {
        return Data_Foldable.elem(Data_Foldable.foldableArray)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.eqPromotionalItem(Restaumatic_Cart_ProductKey.eqProductKey))(promotionalItemEngineItem(item))(v.value1);
    })(promotionalItems);
    var combineable = Data_Array.filter(function (item) {
        return Data_Foldable.elem(Data_Foldable.foldableArray)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.eqPromotionalItem(Restaumatic_Cart_ProductKey.eqProductKey))(promotionalItemEngineItem(item))(v.value0);
    })(promotionalItems);
    return new Data_Tuple.Tuple(combineable, nonCombineable);
};
var promotionalItemPromotion = /* #__PURE__ */ (function () {
    var $36 = Data_Newtype.unwrap();
    return function ($37) {
        return (function (v) {
            return v.promotion;
        })($36($37));
    };
})();
var promotionalItemAvailability = /* #__PURE__ */ (function () {
    var $38 = Data_Newtype.unwrap();
    return function ($39) {
        return (function (v) {
            return v.availability;
        })($38(promotionalItemPromotion($39)));
    };
})();
var promotionalItemCouponPromotion = function ($40) {
    return Restaumatic_Menu_Promotions.isCouponPromotion(promotionalItemPromotion($40));
};
var genericPromotionalItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var eqPromotionalItem = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPromotionalItem)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "promotion";
        }
    })(Restaumatic_Promotions_Types.eqPromotion))()({
        reflectSymbol: function () {
            return "engineItem";
        }
    })(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_PromotionalItem.eqPromotionalItem(Restaumatic_Cart_ProductKey.eqProductKey)))()({
        reflectSymbol: function () {
            return "details";
        }
    })(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString)))()({
        reflectSymbol: function () {
            return "inputOptions";
        }
    })(Restaumatic_Cart_PromotionData.eqPromotionInputOptions))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Promotions_Types_Id.eqPromotionId))()({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))))))))
};
export {
    PromotionalItem,
    promotionalItemDetails,
    promotionalItemPrice,
    promotionalItemSelected,
    promotionalItemSelectable,
    promotionalItemInput,
    promotionalItemPromotion,
    promotionalItemCouponPromotion,
    promotionalItemPromotionId,
    promotionalItemAssignment,
    promotionalItemIsActive,
    promotionalItemEngineItem,
    promotionalItemId,
    promotionalItemsPartitionCombineable,
    promotionalItemAvailability,
    promotionalItemMarketingConsent,
    genericPromotionalItem,
    newtypePromotionalItem,
    eqPromotionalItem,
    showPromotionalItem
};
//# sourceMappingURL=index.js.map
